<template>
    <div id="defaultId1">
        <div id="idH2th7O" class="basic-setting-content  u7E3HKf">
            <!-- 基本信息 -->
            <div id="idNdO1Cu" class="common-form">{{$t('基本信息')}}</div>
            <el-form-item id="idD39aGz" :label="$t('菜品名称')" :rules="[{ required: true, message: $t('请填写菜品名称') }]"
                          prop="product_name">
                <el-input id="id6Xvdg1" v-model="translations[activeName].form.model.product_name" class="max-w460"
                          @blur="validateProductName"></el-input>
                <mi-free-time>
                    <el-button id="id8EApwh" @click="onDishInformation" size="small" type="warning" :loading="loading">
                        {{$t('AI魔法创建')}}
                    </el-button>
                </mi-free-time>
                <div class="wenhao-box">
                    <el-tooltip class="item" effect="light"
                                :content="$t('通过人工智能技术，可以根据菜品名称自动填写菜品详细信息，如配料、卖点、口味等。')"
                                placement="top-start">
                        <span class="wenhao">?</span>
                    </el-tooltip>
                </div>
            </el-form-item>
            <el-form-item id="id5oxfug" :label="$t('所属分类')" :rules="[{ required: true, message:$t('请选择菜品分类')  }]"
                          prop="category_id">
                <el-select id="id2UnOSb" v-model="translations[activeName].form.model.category_id"
                           @change="changeCategory">
                    <template id="id6Em25h">
                        <el-option id="idpvxran" v-for="(cat,index) in translations[activeName].form.category"
                                   :value="cat.category_id" :label="cat.name" :key="index"></el-option>
                    </template>
                </el-select>
                <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus"
                           v-auth="'/product/category/Add'">{{$t('添加分类')}}
                </el-button>
            </el-form-item>
            <el-form-item id="idNkZrFm" :label="$t('菜品详情')" :rules="[{ required: true, message:$t( '请填写菜品详情' )}]"
                          prop="content">
                <el-input id="idqWWjfX" v-model="translations[activeName].form.model.content" class="max-w460"
                          type="textarea"></el-input>
                <mi-free-time>
                    <el-button id="id8EApwh" @click="onRequestContent" size="small" type="warning"
                               :loading="RequestContent_loading">{{$t('换一换')}}
                    </el-button>
                </mi-free-time>
            </el-form-item>
            <!--单规格-->
            <template v-if="translations[activeName].form.model.spec_type == 10">
                <el-row style="min-width:640px ">
                    <el-col :span="8" style="min-width:290px;max-width: 300px">
                        <el-form-item :label="$t('菜品价格')" :rules="[{ required: true, message: $t('请填写菜品价格') }]"
                                      prop="sku[0].product_price">
                            <el-input type="textarea"
                                      :rows="2" style="width: 190px"
                                      v-model="translations[activeName].form.model.sku[0].product_price"
                                      @blur="changeProductPrice"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="min-width:350px;max-width: 300px">
                        <el-form-item :label="$t('包装费')" :rules="[{ required: true, message: $t('请填写包装费') }]"
                                      prop="sku[0].bag_price" label-width="70px">
                            <el-input type="textarea"
                                      :rows="2" style="width: 190px"
                                      v-model="translations[activeName].form.model.sku[0].bag_price"
                                      @blur="changeBagPrice"></el-input>
                            <el-button id="id8EApwh" @click="changeSpec(20)" size="small" type="primary"
                                       :loading="RequestContent_loading">{{$t('多规格')}}
                            </el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>
            <!--多规格-->
            <template v-if="translations[activeName].form.model.spec_type == 20">
                <div class="mt16">
                    <el-form-item :label="$t('规格明细')" v-if="translations[activeName].form.model.sku.length > 0">
                        <!--多规格表格-->
                        <div>
                            <el-table size="mini" :data="translations[activeName].form.model.sku" border
                                      style="width: 60%; margin-top: 5px">
                                <el-table-column :label="$t('规格名称')">
                                    <template slot-scope="scope">
                                        <el-form-item label="" style="margin-bottom: 0;">
                                            <el-autocomplete class="inline-input" v-model="scope.row.spec_name"
                                                             :fetch-suggestions="querySearch"
                                                             :placeholder="$t('请输入内容')"></el-autocomplete>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('价格')">
                                    <template slot-scope="scope">
                                        <el-form-item label="" style="margin-bottom: 0;">
                                            <el-input type="number" size="small" prop="product_price"
                                                      v-model="scope.row.product_price"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('包装费')">
                                    <template slot-scope="scope">
                                        <el-form-item label="" style="margin-bottom: 0;">
                                            <el-input type="number" size="small" prop="bag_price"
                                                      v-model="scope.row.bag_price"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="">
                                    <template slot-scope="scope">
                                        <el-form-item label="" style="margin-bottom: 0;">
                                            <el-button type="text" @click='deleteAttr(scope.$index)'>{{$t('删除')}}</el-button>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div style="text-align: center;width: 60%;margin-top: 10px">
                            <el-button size="small" class="el-icon-circle-plus" type="primary"
                                       @click="onToggleAddGroupForm">{{$t('添加规格')}}
                            </el-button>
                            <el-button size="small" @click="changeSpec(10)">{{$t('单规格')}}</el-button>
                        </div>
                    </el-form-item>
                </div>
            </template>
            <!-- 菜品图片-->
            <div style="display: flex">
                <div style="flex: 1">
                    <el-form-item id="idQdQ8ch" style="width: 25%" :label="$t('菜品图片')"
                                  :rules="[{ required: true, message: $t('请上传菜品图片') }]" prop="image">
                        <div class="yulantu" v-if="translations[activeName].form.model.image.length == 0">
                            <img src="@/assets/img/yulantu.png">
                            <el-button class="select-image-button" size="small" type="primary" @click="openAiBox">
                                {{$t('从AI图库中选择')}}
                            </el-button>
                            <br>
                            <el-button class="select-image-button" size="small" @click="openProductUpload">
                                {{$t('请上传菜品图片')}}
                            </el-button>
                        </div>
                        <div id="idUF8LGW" class="draggable-list" v-else>
                            <draggable id="idGVxXT8" v-model="translations[activeName].form.model.image"
                                       class="wrapper">
                                <transition-group id="idfNq4N4">
                                    <div id="idXTfATS"
                                         v-for="(item, index) in translations[activeName].form.model.image" class="item"
                                         :key="index+item">
                                        <img id="id2qTTU7" v-img-url="item.file_path"/>
                                        <a id="idvRmGgP" class="delete-btn" href="javascript:void(0);"
                                           @click.stop="deleteImg(index)">
                                            <i id="idWmBGmd" class="el-icon-close"></i>
                                        </a>
                                    </div>
                                </transition-group>
                            </draggable>
                            <div id="idkVAiDJ">
                                <el-button class="select-image-button" size="small" type="primary" @click="openAiBox">
                                    {{$t('从AI图库中选择')}}
                                </el-button>
                                <br>
                                <el-button class="select-image-button" size="small" @click="openProductUpload">
                                    {{$t('请上传菜品图片')}}
                                </el-button>
                            </div>
                        </div>
                    </el-form-item>
                </div>
                <div style="" class="ai-image-container" v-if="isShowAiSearch">
                    <div class="title-input-search">
                        <el-input class="ai_search " size="small" style="width: 30%" v-model="ai_search"
                                  @blur="getAiImageList(2)"
                                  :placeholder="$t('使用中文从AI图库搜索')">
                            <template slot="suffix">
                                <i class="el-icon-search fangdajing" @click="getAiImageList(2)"></i>
                            </template>
                        </el-input>
                        <div class="ai-pictures-title">{{$t('AI图库')}}</div>
                        <div class="confirm-use">
                            <el-button size="mini" type="primary" style="margin:5px 5px 0 0"
                                       @click="confirmAiImageSelect">{{$t('确认使用')}}
                            </el-button>
                        </div>
                    </div>
                    <div class="ai-image-list">
                        <div v-if="aliImageList.length != 0">
                            <div class="imagelists" @scroll="loadMore">
                                <div v-for="(item, index) in aliImageList" class="aliImageItem" :key="index+item"
                                     @click="selectFileFunc(item,index)">
                                    <div v-if="item.selected" class="selectedIcon"><i class="el-icon-check duigou"></i>
                                    </div>
                                    <img v-img-url="item.food_url"/>
                                </div>
                            </div>
                        </div>
                        <div class="no-have-image" v-else>
                            <img src="@/assets/img/kulian.svg" width="80">
                            <p>{{$t('AI未识别到您的菜品图片')}}</p>
                            <p>{{$t('可在搜索框')}}<span>{{$t('更换菜品名称')}}</span>~</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 菜品图片组件 -->
            <Upload id="idJRGef8" v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload"
                    :isAspectRatio="false" @returnImgs="returnProductImgsFunc">{{$t('上传图片')}}
            </Upload>
            <!--添加-->
            <AddCat v-if="open_add" :open_add="open_add" @closeDialog="closeDialogFunc($event, 'add')">
            </AddCat>
        </div>
    </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import AddCat from '../../../category/Add.vue';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
import category from "../../../../page/page/category";

export default {
    components: {
        Upload,
        draggable,
        AddCat
    },
    data() {
        return {
            /*是否打开添加弹窗*/
            open_add: false,
            ai_search: '',
            ai_search_type: 0,
            selectedOptions: [], // 用于存储选中的选项
            loading: false,
            getTagLoading: false,
            formData: {},
            isProductUpload: false,
            selling_point_loading: false,//菜品卖点状态
            RequestContent_loading: false,//简介内容状态
            isShowWenHao: false,
            // 分类下拉
            categoryList: [],
            aliImageList: [],
            itemsPerScroll: 0,
            showImageList: [],
            page: 1,
            isShowAiSearch: false,
            /*显示添加规格组按钮*/
            showAddGroupBtn: true,
            /*显示添加规格组表单*/
            showAddGroupForm: false,
            /*新增规格组值*/
            addGroupFrom: {
                specName: '',
                specValue: ''
            },
            groupLoading: false,
            restaurants: [],
            isTranslating: false,
        };
    },
    props: {
        activeName: {
            type: String,
            default: 'chinese'
        },
        product_type: {
            type: Number,
            default: 0
        }
    },
    inject: ['translations'],
    watch: {
        ai_search(newVal, oldVal) {
            if (newVal) {
                this.getAiImageList(2);
            } else {
                this.getAiImageList(1);
            }
        },
        'activeName': {
            handler() {
                this.categoryLabel()
                this.specData()
            },
        },
    },
    created() {
        // this.$nextTick(()=>{
        //   this.categoryLabel()
        // })
    },
    methods: {
        /*关闭添加分类弹窗*/
        closeDialogFunc(e, f) {
            if (f == 'add') {
                this.open_add = e.openDialog;
                if (e.type == 'success') {
                    //这里需要重新获取categoryList
                    PorductApi.storeCatList({}, true)
                        .then(data => {
                            let categoryList = data.data.list
                            for (let key in this.translations) {
                                this.$set(this.translations[key].form, 'category', categoryList);

                                let maxCategoryData = categoryList.reduce((prev, curr) => {
                                    return prev.category_id > curr.category_id ? prev : curr;
                                });
                                console.log('maxCategoryData', maxCategoryData)
                                this.$set(this.translations[key].form.model, 'category_id', maxCategoryData.category_id);
                            }
                        })
                        .catch(error => {

                        });
                }
            }
        },
        /*打开添加分类*/
        addClick() {
            this.open_add = true;
        },
        //同步更新多语言中的分类
        changeCategory() {
            let categoryID = this.translations[this.activeName].form.model.category_id
            for (let key in this.translations) {
                this.$set(this.translations[key].form.model, 'category_id', categoryID);
            }
        },
        //菜品名称非空校验
        async validateProductName() {
            //先判断主语言和当前页面中的语言是否一致，只允许在主语言下的表单进行操作
            let mainLanguage = localStorage.getItem("mainLanguage")
            if (mainLanguage == this.activeName) {
                if (!this.translations[mainLanguage].form.model.product_name) {
                    return
                }
                const param = {
                    product_name: this.translations[mainLanguage].form.model.product_name,
                    product_type: this.product_type  //0:外卖  1:店内
                }

                if (this.$route.query.scene != 'edit') {
                    PorductApi.validate_product_name(param, true).then(res => {
                        if (res.code === 1 && res.msg === '该菜品已存在') {
                            this.$message.warning(res.msg)
                        }
                    })
                }
                let languageList = Object.keys(this.translations).filter(key => key !== mainLanguage);
                console.log('languageList', languageList)
                //去翻译 菜名的其他语言
                await this.requestServerTranslate(this.translations[mainLanguage].form.model.product_name, '', 'product_name')
                //菜名翻译完了，去通知状态组件
                this.$emit('notifyLangList', this.composeLangStatus(2), '菜品名称翻译完成');
                if (this.translations.chinese.form.model.product_name != "") {
                    this.ai_search = this.translations.chinese.form.model.product_name
                    this.isShowAiSearch = true
                    this.getAiImageList(1)
                }
            }
        },
        //AI魔法创建
        async onDishInformation() {
            let self = this;
            let mainLanguage = localStorage.getItem("mainLanguage")
            if (mainLanguage == this.activeName) {
                if (self.translations[mainLanguage].form.model.product_name.length == 0) {
                    this.$message({
                        type: 'info',
                        message: self.$t('请输入菜品名称！')
                    });
                    return;
                }
                self.loading = true;
                let res = await PorductApi.dishInformation_tag(self.translations[mainLanguage].form.model.product_name, {}, true)
                let tagArr = res.data.response

                //菜品标签
                self.translations[mainLanguage].form.model.tag = JSON.parse(tagArr);
                console.log('tagArr', tagArr)
                console.log('JSON.parse(tagArr)', JSON.parse(tagArr))
                this.selectedOptions = self.translations[mainLanguage].form.model.tag
                if (this.selectedOptions.length > 0) {
                    self.translations[mainLanguage].form.model.product_tag = []
                    for (let item of this.selectedOptions) {
                        self.translations[mainLanguage].form.model.product_tag.push({
                            tag_name: item,
                            sort: 1,
                        });
                    }

                }
                let resInfo = await PorductApi.dishInformation(self.translations[mainLanguage].form.model.product_name, mainLanguage, {}, true)
                const params = JSON.parse(resInfo.data.response)
                this.$emit('translateLoading', true);

                //菜品详情
                self.translations[mainLanguage].form.model.content = params.description;
                await this.requestServerTranslate(params.description, '', 'content')
                this.$emit('notifyLangList', this.composeLangStatus(2), '菜品详情翻译完成');

                //基本信息
                self.translations[mainLanguage].form.model.taste = params.taste;//口味
                //去翻译 口味的其他语言
                await this.requestServerTranslate(params.taste, '', 'taste')
                this.$emit('notifyLangList', this.composeLangStatus(2), '口味已翻译完成');

                //菜品卖点
                self.translations[mainLanguage].form.model.selling_point = params.feature;
                await this.requestServerTranslate(params.feature, '', 'selling_point')
                this.$emit('notifyLangList', this.composeLangStatus(2), '菜品卖点已翻译完成');

                //菜品配料
                self.translations[mainLanguage].form.model.ingredient = [];
                console.log("params.ingredients", params.ingredients);
                if (Array.isArray(params.ingredients) && params.ingredients.length > 0) {
                    this.$emit('notifyLangList', this.composeLangStatus(1), '菜品配料翻译中...');
                    for (let langkey in this.translations) {
                        if (langkey != mainLanguage) {
                            self.translations[langkey].form.model.ingredient = [];
                        }
                    }
                    for (let item of params.ingredients) {
                        self.translations[mainLanguage].form.model.ingredient.push({
                                ingredient_name: item,
                                sort: 1,
                            }
                        )
                        let languageList = Object.keys(this.translations).filter(key => key !== mainLanguage);
                        console.log('languageList', languageList)
                        let translateData = {
                            "word": item,
                            "from_language": mainLanguage,
                            "languages": languageList,
                        }
                        let res1 = await PorductApi.translate_words(translateData, true)
                        if (res1.code == 1) {
                            let translatedRes = res1.data.response
                            for (let k in translatedRes) {
                                if (k == 'croatian') {
                                    this.translations['croatia'].form.model.ingredient.push({
                                        ingredient_name: translatedRes['croatian'],
                                        sort: 1,
                                    })
                                } else if (k == 'slovenian') {
                                    this.translations['slovenia'].form.model.ingredient.push({
                                        ingredient_name: translatedRes['slovenian'],
                                        sort: 1,
                                    })
                                } else {
                                    this.translations[k].form.model.ingredient.push({
                                        ingredient_name: translatedRes[k],
                                        sort: 1,
                                    })
                                }


                            }
                        }
                    }
                    this.$emit('notifyLangList', this.composeLangStatus(2), '菜品配料翻译完成');
                }
                for (let languageKey in this.translations) {
                    //规格库存
                    self.translations[languageKey].form.model.deduct_stock_type = 10; //扣减库存方式 "10">下单减库存 20">付款减库存
                    self.translations[languageKey].form.model.product_unit = "份" //菜品单位
                    // self.translations[languageKey].form.model.spec_type = 10;
                    self.translations[languageKey].form.model.product_price = "1"; //菜品价格
                    self.translations[languageKey].form.model.stock_num = "999"; //库存数量
                    //积分
                    self.translations[languageKey].form.model.is_points_gift = 0;
                    //初始销量
                    self.translations[languageKey].form.model.sales_initial = "0";
                    //限购数量
                    self.translations[languageKey].form.model.limit_num = 0;
                    //菜品排序
                    self.translations[languageKey].form.model.product_sort = 100;
                    //会员折扣
                    self.translations[languageKey].form.model.is_enable_grade = 0; //是否开启会员折扣 1开启
                    self.translations[languageKey].form.model.is_alone_grade = 0; // 0默认折扣  1单独设置折扣
                }
                self.loading = false;
                this.$emit('translateLoading', false);
            } else {
                alert(self.$t("请在主语言界面上进行操作"));
                this.$emit('active-name-changed', mainLanguage);
            }
        },
        //菜品详情换一换
        async onRequestContent() {
            let self = this;
            let mainLanguage = localStorage.getItem("mainLanguage")
            if (mainLanguage == this.activeName) {
                self.RequestContent_loading = true;
                let res = await PorductApi.dishInformation_description(self.translations[mainLanguage].form.model.product_name, localStorage.getItem('mainLanguage'), {}, true)
                self.RequestContent_loading = false;
                //菜品卖点
                self.translations[mainLanguage].form.model.content = res.data.response;
                for (let key in this.translations) {
                    if (key !== mainLanguage) {
                        await this.requestServerTranslate(res.data.response, key, 'content')
                        this.$emit('notifyLangList', this.composeLangStatus(2), '菜品详情');
                    }
                }
            } else {
                alert(self.$t("请在主语言界面上进行操作") );
                this.$emit('active-name-changed', mainLanguage);
            }
        },
        //菜品卖点换一换
        onSellingPoint() {
            let mainLanguage = localStorage.getItem("mainLanguage")
            if (mainLanguage == this.activeName) {
                let self = this;
                self.selling_point_loading = true;
                PorductApi.dishInformation_featrue(self.translations[mainLanguage].form.model.product_name, mainLanguage, {}, true).then(res => {
                    self.selling_point_loading = false;
                    //菜品卖点
                    self.translations[mainLanguage].form.model.selling_point = res.data.response;
                }).catch(error => {
                    self.selling_point_loading = false;
                });
            } else {
                alert(self.$t("请在主语言界面上进行操作"));
                this.$emit('active-name-changed', mainLanguage);
            }
        },
        changeSpec(e) {
            for (let langKey in this.translations) {
                this.translations[langKey].form.model.spec_type = e
            }
            if (e == 10) {
                if (this.translations[this.activeName].form.model.spec_type != 10) {
                    for (let key in this.translations) {
                        this.translations[key].form.model.sku = []
                        this.translations[key].form.model.sku[0] = {
                            product_price: '',
                            stock_num: 999,
                            bag_price: '',
                            cost_price: 0,
                            is_full: 0
                        }
                    }
                }
            } else if (e == 20) {
                if (this.translations[this.activeName].form.model.spec_type != 20) {
                    for (let key in this.translations) {
                        this.translations[key].form.model.sku = []
                    }
                }
            }
        },
        //菜品单规格价格
        changeProductPrice() {
            let productPrice = this.translations[this.activeName].form.model.sku[0].product_price
            for (let key in this.translations) {
                if (key !== this.activeName) {
                    this.translations[key].form.model.sku[0].product_price = productPrice
                }
            }
        },
        changeBagPrice() {
            let bagPrice = this.translations[this.activeName].form.model.sku[0].bag_price
            for (let key in this.translations) {
                if (key !== this.activeName) {
                    this.translations[key].form.model.sku[0].bag_price = bagPrice
                }
            }
        },
        //用户更改langList的顺序和状态值
        composeLangStatus(status) {
            let mainLanguage = localStorage.getItem("mainLanguage");
            // 先找到主语言的项
            let mainLangItem = Object.keys(this.translations)
                .filter(key => key === mainLanguage)
                .map(key => {
                    return {
                        text: this.translations[key].text,
                        status: key === mainLanguage ? 3 : status,
                        name: this.translations[key].name
                    };
                });
            // 然后找到其它的项
            let otherItems = Object.keys(this.translations)
                .filter(key => key !== mainLanguage)
                .map(key => {
                    return {
                        text: this.translations[key].text,
                        status: status,
                        name: this.translations[key].name
                    };
                });
            // 合并主语言项和其它项
            let langList = [...mainLangItem, ...otherItems];
            return langList;
        },
        //请求翻译
        async requestServerTranslate(word, language, filedName) {
            let translateFiled = ""
            if (filedName == "product_name") {
                translateFiled = "菜品名称"
            }
            if (filedName == "taste") {
                translateFiled = "口味"
            }
            if (filedName == "selling_point") {
                translateFiled = "菜品卖点"
            }
            if (filedName == "content") {
                translateFiled = "菜品详情"
            }
            this.$emit('notifyLangList', this.composeLangStatus(1), translateFiled + '翻译中...');
            let mainLanguage = localStorage.getItem("mainLanguage")
            if (mainLanguage == this.activeName) {
                let languageList = Object.keys(this.translations).filter(key => key !== mainLanguage);
                console.log('languageList', languageList)
                let translateData = {
                    "word": word,
                    "from_language": mainLanguage,
                    "languages": languageList,
                }
                let res = await PorductApi.translate_words(translateData, true)
                if (res.code == 1) {
                    let translatedRes = res.data.response
                    //拿到大模型返回的翻译数据
                    console.log("翻译菜品名称返回来的数据", translatedRes)
                    for (let key in translatedRes) {
                        if (key == 'croatian') {
                            this.translations['croatia'].form.model[filedName] = translatedRes[key]
                        } else if (key == 'slovenian') {
                            this.translations['slovenia'].form.model[filedName] = translatedRes[key]
                        } else {
                            this.translations[key].form.model[filedName] = translatedRes[key]
                        }
                    }
                }
            }
        },
        //选择的ai图库确认操作
        confirmAiImageSelect() {
            const selectedItems = this.aliImageList.filter(item => item.selected);
            const selectedIds = selectedItems.map(item => item.id);
            const selectedIdsStr = selectedIds.join(',');
            PorductApi.set_ai_image_file({'params': selectedIdsStr}, true).then(res => {
                if (res.code == 1) {
                    for (let key in this.translations) {
                        this.translations[key].form.model.image = []
                        this.$set(this.translations[key].form.model, 'image', res.data.file_list);
                    }
                }
            })
        },
        //ai图库的列表选择操作
        selectFileFunc(item, index) {
            let alreadySelected = item.selected;
            this.aliImageList.forEach((file) => {
                file.selected = false;
            });
            // 如果当前点击的图片之前没有被选中，那么将其设置为选中状态
            if (!alreadySelected) {
                this.$nextTick(() => {
                    this.aliImageList[index].selected = true;
                });
            }
        },
        //滚动加载ai图库列表
        loadMore() {
            var scrollHeight = event.target.scrollHeight;
            var scrollTop = event.target.scrollTop;
            var clientHeight = event.target.clientHeight;
            if (scrollTop + clientHeight >= scrollHeight) {
                // 如果已滚动到底部，加载更多图片
                this.fetchMoreImages();
            }
        },
        fetchMoreImages() {
            this.page += 1;
            // 在加载更多图片时，增加 page 的值
            if (this.ai_search_type == 0) {
                this.getAiImageList(1, this.page);
            }
            if (this.ai_search_type == 1) {
                this.getAiImageList(2, this.page);
            }
        },
        //获取AI图库列表
        getAiImageList(type, page = 1) {
            let foodName
            if (type == 1) {
                this.ai_search_type = 0
                foodName = this.translations.chinese.form.model.product_name
            }
            if (type == 2) {
                this.ai_search_type = 1
                foodName = this.ai_search
            }
            PorductApi.get_ai_image_list(foodName, page, true).then(res => {
                console.log(res)
                // 如果是加载更多图片，将新加载的图片添加到 aliImageList 的末尾
                // 否则，用新加载的图片替换现有的图片
                if (page > 1) {
                    this.aliImageList = [...this.aliImageList, ...res.data.file_list.data.map(item => {
                        return {
                            "id": item.id,
                            "food_url": item.food_url,
                            "food_name": item.food_name,
                            "keyword": item.keyword,
                            "selected": false,
                        };
                    })];
                } else {
                    this.aliImageList = res.data.file_list.data.map(item => {
                        return {
                            "id": item.id,
                            "food_url": item.food_url,
                            "food_name": item.food_name,
                            "keyword": item.keyword,
                            "selected": false,
                        };
                    });
                }
            }).catch(error => {
            });
        },
        // 所属分类展示
        categoryLabel() {
            if (this.translations && this.translations[this.activeName]) {
                this.translations[this.activeName].form.category = this.translations[this.activeName].form.category.map(item => {
                    let category, name;
                    if (item.lang && item.lang.category) {
                        category = JSON.parse(item.lang.category)
                        if (category) {
                            const key = this.activeName
                            if (category[key] != undefined) {
                                name = category[key]
                            } else {
                                name = item.name
                            }
                        } else {
                            name = item.name
                        }
                        return {
                            category_id: item.category_id,
                            name: name
                        }
                    } else {
                        return {
                            category_id: item.category_id,
                            name: item.name
                        }
                    }
                })
            }
        },
        //菜品规格数据
        specData() {
            let mainLanguage = localStorage.getItem("mainLanguage")
            for (let key in this.translations) {
                if (mainLanguage != key && this.activeName != mainLanguage) {
                    // console.log(this.translations[key], mainLanguage)
                    this.translations[key].form.model.sku = []
                    this.translations[key].form.model.sku = this.translations[mainLanguage].form.model.sku
                }
            }
        },

        toggleWenHao() {
            this.isShowWenHao = !this.isShowWenHao;
        },
        handleScroll() {
            this.isShowWenHao = false;
        },
        //获取标签
        getTagAction() {
            let mainLanguage = localStorage.getItem('mainLanguage')
            let self = this;
            if (self.translations[mainLanguage].form.model.product_name.length == 0) {
                this.$message({
                    type: 'info',
                    message: self.$t('请输入菜品名称！')
                });
                return;
            }
            this.getTagLoading = true
            PorductApi.dishInformation_tag(self.translations[mainLanguage].form.model.product_name, {}, true).then(res => {
                this.getTagLoading = false
                let tagArr = res.data.response
                //菜品标签
                this.translations[mainLanguage].form.model.tag = JSON.parse(tagArr);
                this.selectedOptions = this.translations[mainLanguage].form.model.tag
                this.translations[mainLanguage].form.model.product_tag = []
                if (Array.isArray(this.selectedOptions) && this.selectedOptions.length > 0) {
                    for (let item of this.selectedOptions) {
                        this.translations[mainLanguage].form.model.product_tag.push({
                            tag_name: item,
                            sort: 1,
                        });
                    }
                }
            }).catch(error => {
                this.getTagLoading = false
                console.log("获取标签出错了")
            });
        },
        //删除图片操作
        deleteImg(index) {
            // this.translations[this.activeName].form.model.image.splice(index, 1);
            for (let key in this.translations) {
                this.translations[key].form.model.image.splice(index, 1)
            }
        },
        openProductUpload() {
            this.isProductUpload = true;
            this.isShowAiSearch = false;
        },
        //ai图库布局是否展示
        openAiBox() {
            this.isShowAiSearch = !this.isShowAiSearch;
        },
        returnProductImgsFunc(e) {
            if (e != null) {
                let imgs = e || '';
                for (let key in this.translations) {
                    this.$set(this.translations[key].form.model, 'image', imgs);
                }
            }
            this.isProductUpload = false;
        },
        /*显示/隐藏添加规则组 */
        onToggleAddGroupForm: function () {
            let mainLanguage = localStorage.getItem("mainLanguage")
            let self = this;
            if (!Array.isArray(self.translations[mainLanguage].form.model.sku)) {
                for (let key in this.translations) {
                    self.translations[key].form.model.sku = [];
                }
            }
            self.translations[mainLanguage].form.model.sku.push(
                {
                    spec_name: '',
                    product_price: '',
                    bag_price: '',
                    stock_num: 999,
                    cost_price: 0,
                    is_full: 0
                });
        },
        /*删除规格组事件*/
        onDeleteGroup: function (index) {
            var self = this;
            self
                .$confirm(self.$t('删除后不可恢复，确认删除该记录吗?'), self.$t('提示'), {
                    type: 'warning'
                })
                .then(() => {
                    // 删除指定规则组
                    for (let key in this.translations) {
                        self.translations[key].form.model.spec_many.spec_attr.splice(index, 1);
                    }
                    // 构建规格组合列表
                    self.buildSkulist();
                });
        },
        /*删除规格值值事件*/
        onDeleteValue: function (index, itemIndex) {
            let self = this;
            if (self.form.isSpecLocked) {
                self.$message({
                    message: self.$t('本菜品正在参加活动，不能删除规格！'),
                    type: 'warning'
                });
                return;
            }

            self
                .$confirm(self.$t('删除后不可恢复，确认删除该记录吗?'),self.$t('提示') , {
                    type: 'warning'
                })
                .then(() => {
                    // 删除指定规则组
                    self.translations[this.activeName].form.model.spec_many.spec_attr[index].spec_items.splice(itemIndex, 1);
                    // 构建规格组合列表
                    self.buildSkulist();
                });
        },
        deleteAttr(i) {
            let self = this
            if (i == 0) {
                self.$message({
                    message: self.$t('不能再删除了'),
                    type: 'warning'
                });
                return
            } else {
                for (let key in this.translations) {
                    this.translations[key].form.model.sku.splice(i, 1)
                }
            }
        },
        querySearch(queryString, cb) {
            if (this.restaurants.length == 0) {
                this.translations[this.activeName].form.spec.forEach((item, index) => {
                    this.restaurants.push({
                        value: item.spec_name
                    })
                })
            }
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        /*构建规格组合列表*/
        buildSkulist: function () {
            let self = this;
            let mainLanguage = localStorage.getItem("mainLanguage")
            let spec_attr = self.translations[mainLanguage].form.model.spec_many.spec_attr;
            let specArr = [];
            for (let i = 0; i < spec_attr.length; i++) {
                specArr.push(spec_attr[i].spec_items);
            }
            let specListTemp = self.calcDescartes(specArr);
            let specList = [];
            for (let i = 0; i < specListTemp.length; i++) {
                let rows = [];
                let specSkuIdAttr = [];
                if (!Array.isArray(specListTemp[i])) {
                    rows.push(specListTemp[i]);
                } else {
                    rows = specListTemp[i];
                }
                for (let j = 0; j < rows.length; j++) {
                    specSkuIdAttr.push(rows[j].item_id);
                }
                specList.push({
                    product_sku_id: 0,
                    spec_sku_id: specSkuIdAttr.join('_'),
                    rows: rows,
                    spec_form: {}
                });
            }
            // 合并旧sku数据
            if (self.translations[mainLanguage].form.model.spec_many.spec_list.length > 0 && specList.length > 0) {
                for (let i = 0; i < specList.length; i++) {
                    let overlap = self.translations[mainLanguage].form.model.spec_many.spec_list.filter(function (val) {
                        return val.spec_sku_id === specList[i].spec_sku_id;
                    });
                    if (overlap.length > 0) {
                        specList[i].spec_form = overlap[0].spec_form;
                        specList[i].product_sku_id = overlap[0].product_sku_id;
                    }
                }
            }
            for (let key in this.translations) {
                self.translations[key].form.model.spec_many.spec_list = specList;
            }
        },

        /*规格组合*/
        calcDescartes: function (array) {
            if (array.length < 2) return array[0] || [];
            return [].reduce.call(array, function (col, set) {
                let res = [];
                col.forEach(function (c) {
                    set.forEach(function (s) {
                        let t = [].concat(Array.isArray(c) ? c : [c]);
                        t.push(s);
                        res.push(t);
                    });
                });
                return res;
            });
        },
    },
    async mounted() {
        this.$emit('notifyLangList', this.composeLangStatus(0));
        let lang = localStorage.getItem("mainLanguage")
        if (lang) {
            this.$emit('ready', lang)
        }

    }
};
</script>
<style scoped lang="scss">
.ai-image-container {
    flex: 4;
    width: 80%;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 1px solid #dddddd;
    min-width: 500px;
}

.title-input-search {
    display: flex;
}

.title-input-search .fangdajing {
    font-size: 13px;
    line-height: 30px;
}

.title-input-search .fangdajing:hover {
    cursor: pointer;
}

.title-input-search .ai_search {
    flex: 1;
    margin-top: 2px;
    margin-left: 2px;
    font-size: 12px;
}

.title-input-search .confirm-use {
    text-align: right;
    flex: 1;
}

.title-input-search .ai-pictures-title {
    flex: 1;
    text-align: center;
    font-size: 18px;
    color: #E6A23C;
    font-weight: 700 !important;
}

.imagelists {
    margin-top: 5px;
    margin-left: 2px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    height: 110px; /* 你可以设置你需要的高度 */
    overflow-y: auto; /* 当内容超出高度时显示滚动条 */
}

.aliImageItem {
    width: 110px;
    height: 110px;
    margin-left: 5px;
    margin-bottom: 10px;
    position: relative;
}

.aliImageItem img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    object-fit: contain;
}

.no-have-image {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    span {
        font-weight: bold;
    }
}

.no-have-image p {
    font-size: 15px;
    color: #838383;
}

.draggable-list .select-image-button {
    width: 130px;
    margin-top: 5px;
}

.yulantu {
    width: 130px;
    margin-top: 10px;
}

.yulantu .select-image-button {
    width: 100%;
    margin-top: 5px;
}

.yulantu img {
    display: block;
    width: 128px;
    height: 102px;
    border-radius: 8px;
}

.selectedIcon {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    background: #ff9900;
    z-index: 1;
    color: #FFFFFF;
    cursor: pointer;
    border-radius: 5px;
}

.selectedIcon .duigou {
    position: relative;
    top: 0;
    left: 5px;
}

.draggable-list .wrapper > span {
    /*display: flex;*/
    /*justify-content: flex-start;*/
    /*flex-wrap: wrap;*/
}

.draggable-list .item {
    position: relative;
    width: 128px;
    height: 102px;
    border-radius: 8px;
    margin-top: 10px;
    margin-right: 5px;
    overflow: hidden;
    border: 1px solid #dddddd;
}

.draggable-list .uploadfile {
    width: 128px;
    height: 102px;
    margin-top: 10px;
    margin-right: 5px;
    border-radius: 8px;
    border: 1px solid red;
}

.draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
}

.draggable-list .item:hover .delete-btn {
    display: block;
}

.draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
}

/*.draggable-list .img-select-btn {*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  border: 1px solid #dddddd;*/
/*  background-color: #409eff;*/
/*  font-size: 15px;*/
/*  padding: 5px;*/
/*  color: #fff;*/
/*  border-radius: 3px;*/
/*}*/

/*.draggable-list .no-select-image {*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  border: 1px dashed #dddddd;*/
/*  font-size: 30px;*/
/*  margin: 140px auto;*/
/*}*/

.draggable-list .no-select-image i {
    color: #409eff;
}

/*.draggable-list .img-select i {*/
/*  color: #409eff;*/
/*}*/
.u7E3HKf {
    margin-right: 15px;
}

.wenhao-box {
    display: inline-block;
    position: relative;
}

.wenhao {
    width: 16px;
    height: 16px;
    border: 1px solid #DCDFE6;
    border-radius: 8px;
    line-height: 14px;
    text-align: center;
    font-size: 15px;
    display: inline-block;
    margin-top: 10px;
    color: #DCDFE6;
}

.wenhao:hover {
    cursor: pointer;
    border: 1px solid #409EFF;
    color: #409EFF;
}

.uiNJkJ4 {
    display: flex;
    justify-content: flex-start;
    width: auto;
}

.uBuIHG1 {
    display: flex;
    justify-content: center;
    width: inherit;
    flex: none;
    flex-direction: row;
    text-align: center;
    cursor: pointer;
    box-sizing: inherit;
    flex-wrap: nowrap;
}

.uFZHTog {
    display: flex;
    flex-direction: row;
}

.spec-many-type {
    margin-left: 180px;
    margin-top: 16px;
    padding: 20px;
    border: 1px solid #e5ecf4;
    background: #f6f9fc;
}

.spec-wrap .spec-hd {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    font-weight: bold;
}

.spec-wrap .spec-hd .el-icon-delete-solid {
    font-size: 16px;
    color: #999999;
}

.spec-wrap .min-spc {
    border: 1px solid #dfecf8;
}

.spec-wrap .spec-bd {
    padding: 5px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    border-top: 1px solid #dfecf8;
    background: #ffffff;
}

.spec-wrap .spec-bd .el-tag {
    color: #333333;
}

.spec-wrap .spec-bd .item {
    position: relative;
    padding: 5px;
}

.spec-wrap .spec-bd .item input {
    padding-right: 30px;
}

.spec-wrap .spec-hd a,
.spec-wrap .spec-hd .svg-icon,
.spec-wrap .spec-bd .item .svg-icon {
    display: block;
    width: 16px;
    height: 16px;
}

.spec-wrap .spec-bd .item a {
    position: absolute;
    top: 6px;
    right: 5px;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.add-spec .from-box {
    display: flex;
    justify-content: flex-start;
}

.add-spec .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 200px;
    margin-right: 20px;
}

.add-spec .item .key {
    display: block;
    white-space: nowrap;
}

</style>



// WEBPACK FOOTER //
// src/views/product/store/product/part/NewBasic.vue